export * from './feature-list.component';
export * from './feature-list-binding.directive';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/feature/feature-list/index.ts